export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 0_02.2e15aeef.jpg";